function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Pushes a callback onto the BioTRUST Trackers.js Data Layer
 * @param {(tracker: TrackersManager) => void} action
 */
export function trackersPush(action) {
  var _ref = window.bt || {},
      _ref$settings = _ref.settings;

  _ref$settings = _ref$settings === void 0 ? {} : _ref$settings;
  var _ref$settings$tracker = _ref$settings.trackersDataLayer,
      trackersDataLayer = _ref$settings$tracker === void 0 ? 'trackersJsDataLayer' : _ref$settings$tracker;
  window[trackersDataLayer].push(action);
}
/**
 * Pushes a custom event action onto the BioTRUST Trackers.js Data Layer
 * @param {string} eventName
 * @param {string} eventCategory
 * @param {string | undefined} [eventLabel]
 * @param {object} [eventProperties]
 */

export function pushCustomEvent(eventName, eventCategory, eventLabel) {
  var eventProperties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  trackersPush(function (trackers) {
    trackers.action('custom-event', eventName, eventCategory, _objectSpread({
      label: eventLabel
    }, eventProperties));
  });
}
/**
 * Triggers the 'AddToCart' event for tracking purposes.
 * @param {AjaxCartAdapter | StorefrontCartAdapter | BTCheckoutCartAdapter} adapter -
 * An instance of a class that extends CartAdapterBase. This is used to convert the cart data to a tracker usable model.
 */

export function trackAddToCartEvent(adapter) {
  trackersPush(function (trackers) {
    trackers.event('AddToCart', adapter.toAddToCartModel(), adapter.cart);
  });
}
/**
 * Triggers the 'BeginCheckout' (GA) AND 'InitiateCheckout' (Facebook) event for tracking purposes.
 * @param {AjaxCartAdapter | StorefrontCartAdapter | BTCheckoutCartAdapter} adapter -
 * An instance of a class that extends CartAdapterBase. This is used to convert the cart data to a tracker usable model.
 */

export function trackBeginCheckoutEvent(adapter) {
  trackersPush(function (trackers) {
    trackers.action('ec', '', 'checkout', adapter.toBeginCheckoutModel());
    trackers.action('initiate-checkout', adapter.toInitiateCheckoutModel());
  });
}